import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ISpacerComponent) {
    (function(ISpacerComponentStyle) {
        ISpacerComponentStyle.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ISpacerComponent.ISpacerComponentStyle || (ISpacerComponent.ISpacerComponentStyle = {}));
    (function(SpacerVariant) {
        SpacerVariant["SPACER_VARIANT_UNKNOWN"] = "SPACER_VARIANT_UNKNOWN";
        /**
     * No content spacer
     */ SpacerVariant["DEFAULT"] = "DEFAULT";
        /**
     * Horizontal line spacer
     */ SpacerVariant["HORIZONTAL_LINE"] = "HORIZONTAL_LINE";
    })(ISpacerComponent.SpacerVariant || (ISpacerComponent.SpacerVariant = {}));
    ISpacerComponent.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(ISpacerComponent || (ISpacerComponent = {}));
export var ISpacerComponent;
